// src/components/intake/StatusChip.jsx
//
// A submission's status as a pill. Each status takes its semantic ink and the
// tint made for it in theme.js, so the pill reads as a shape, not floating text.

import React from 'react';
import { Box } from '@mui/material';
import { tokens } from '../../theme';
import { STATUS_LABEL } from '../../utils/intake';
import { SP, FONT } from './intakeSx';

const LOOK = {
  under_review: { ink: tokens.color.info, ground: tokens.color.infoTint },
  changes_requested: { ink: tokens.color.warning, ground: tokens.color.warningTint },
  approved: { ink: tokens.color.success, ground: tokens.color.successTint },
};

export default function StatusChip({ status }) {
  const look = LOOK[status] || { ink: SP.gray, ground: SP.lavender };
  return (
    <Box
      component="span"
      data-testid="intake-status"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.1,
        py: '3px',
        borderRadius: '999px',
        fontFamily: FONT.mono,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '.02em',
        whiteSpace: 'nowrap',
        color: look.ink,
        background: look.ground,
      }}
    >
      {STATUS_LABEL[status] || status}
    </Box>
  );
}
